import React , { memo, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { faClock, faBookmark } from '@fortawesome/free-regular-svg-icons'
import OwlCarousel from "react-owl-carousel";
import NoImage from '../../../images/no-image.png'
import CryptoJS from "crypto-js";

const Session = (props) => {
    const {
        handlerModalEvent
    } = props
    const sessionDashboard = useSelector(state=> state.eventState.sessionDashboard )
    const History = useHistory()
    const NavigationOwl = useRef();

    const [speakers] = useState([
        // {
        //     id: 'KwePOTCJRailpUMhdXUNUlrnE7Yz2kDcCGTU320oeKw',
        //     fullname: 'Haris Altest Sajo',
        //     profession: 'CEO & Founder',
        //     organization: 'Drag Taste'
        // },
    ])

    const handleOwlNav = (e, ops) => {
        if(e) e.preventDefault()
        if (ops === 'prev') {
            NavigationOwl.current.prev(500)
        } else if (ops === 'next') {
            NavigationOwl.current.next(500)
        }
    }

    const converterDate = (data) => {
        if (data) {
            let flag = null
            let dateConvertFrom
            let dateConvertTo
            let timeStart
            let timeEnd
            let timeZone
            if(data.show_date) {
                flag = true
                dateConvertFrom = data.show_date
                if (data.starttime) {
                    timeStart = data.starttime
                }
                if (data.endtime) {
                    timeEnd = data.endtime
                }
                if (data.time_zone) {
                    timeZone = data.time_zone
                }
                if(data.show_date_end) {
                    if (data.show_date !== data.show_date_end) {
                        dateConvertTo = data.show_date_end
                    }
                }
            }
            if (!flag) return ' Cooming Soon'
            return dateConvertTo ? ` ${dateConvertFrom} ${timeStart ? `| ${timeStart}` : ''} ${timeZone ? timeZone : ''} ${dateConvertTo ? ` - ${dateConvertTo}` : ''} ${timeEnd ? `| ${timeEnd}` : ''} ${timeZone ? timeZone : ''}` : ` ${dateConvertFrom} ${timeStart ? `| ${timeStart}` : ''} ${timeEnd ? ` - ${timeEnd}` : ''} ${timeZone ? timeZone : ''}`
        }
    }

    const handleParams = (data) => {
        if (data) {
            var encryptUser = CryptoJS.AES.encrypt(JSON.stringify({ id: data.id }), 'elive-livelife22').toString();
            History.push(`/watch/q?id=${encryptUser}`)
            goOnTop()
        }
    }

    const goOnTop = () => {
        window.scroll({
            top: 0, 
            left: 0,
            behavior: 'smooth'
        });
    }

    return (
        sessionDashboard?.length &&
        <section className="px-3 py-4">
          <div className="container" style={{ maxWidth: '850px' }}>
            {/* Header */}
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h2 className="fw-bold text-dark mb-0" style={{ fontSize: '1.25rem' }}>
                Featured Sessions
              </h2>
              <a onClick={e=> History.push('/stage')} className="text-decoration-none fw-medium" style={{ color: '#555aea', fontSize: '0.875rem' }}>
                View All
              </a>
            </div>
        
            {/* Session List */}
            <div className="d-flex flex-column gap-3">
              {sessionDashboard?.map((session, i) => (
                <div
                  key={i.toString()}
                  className="bg-white rounded-3 shadow-sm overflow-hidden"
                  style={{ transition: 'box-shadow 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.boxShadow = '0 .5rem 1rem rgba(0,0,0,.15)'}
                  onMouseLeave={e => e.currentTarget.style.boxShadow = ''}
                >
                  <div className="d-flex">
                    {/* Thumbnail */}
                    <div className="position-relative flex-shrink-0" style={{ width: '128px', height: '128px' }}>
                      <img
                        src={session?.program_info?.image_banner_url || NoImage}
                        alt={session?.program_info?.programme_name}
                        className="w-100 h-100"
                        style={{ objectFit: 'cover'}}
                      />
                    </div>
        
                    {/* Content */}
                    <div className="flex-grow-1 p-3 d-flex flex-column justify-content-between">
                      <div>
                        <h3
                          className="fw-semibold text-dark mb-1"
                          style={{
                            fontSize: '0.875rem',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden'
                          }}
                        >
                          {session?.program_info?.programme_name}
                        </h3>
                        <p className="text-secondary mb-0" style={{ fontSize: '0.75rem' }}>
                          {session?.program_info?.description}
                        </p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <span className="text-secondary" style={{ fontSize: '0.75rem' }}>
                          {converterDate(session?.program_info)}
                        </span>
                        <button
                          className="border-0 text-white px-3 py-1 rounded-2 fw-medium"
                          style={{
                            backgroundColor: '#555aea',
                            fontSize: '0.75rem',
                            transition: 'background-color 0.2s'
                          }}
                          onMouseEnter={e => e.currentTarget.style.backgroundColor = '#6c71ef'}
                          onMouseLeave={e => e.currentTarget.style.backgroundColor = '#555aea'}
                          onClick={_=> handleParams(session && session.program_info) }
                        >
                          Watch
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
    )
};

export default memo(Session);
